// @ts-check
import IndexPage from '@/components/pages/bulkSend/IndexPage.vue';
import CreatePage from '@/components/pages/bulkSend/CreatePage.vue';
import StepsPage from '@/components/pages/bulkSend/StepsPage.vue';
import NamePage from '@/components/pages/bulkSend/NamePage.vue';
import SharingPage from '@/components/pages/bulkSend/SharingPage.vue';
import SigningSequencePage from '@/components/pages/bulkSend/SigningSequencePage.vue';
import RemindersPage from '@/components/pages/bulkSend/RemindersPage.vue';
import ExpiryPage from '@/components/pages/bulkSend/ExpiryPage.vue';
import TemplatesPage from '@/components/pages/bulkSend/TemplatesPage.vue';
import RolesPage from '@/components/pages/bulkSend/RolesPage.vue';
import ImportDataPage from '@/components/pages/bulkSend/ImportDataPage.vue';
import ReviewDataPage from '@/components/pages/bulkSend/ReviewDataPage.vue';
import MessagePage from '@/components/pages/bulkSend/MessagePage.vue';
import UsagePage from '@/components/pages/bulkSend/UsagePage.vue';
import SummaryPage from '@/components/pages/bulkSend/SummaryPage.vue';

const commonRoutes = (type = 'Step') => [
  {
    /**
     * url: /bulk-send/:fingerprint(/edit)/name
     *
     * Step 1 - Name
     */
    path: 'name',
    name: `BulkSends${type}Name`,
    component: NamePage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
  {
    /**
     * Step 2 - Sharing
     */
    path: 'sharing',
    name: `BulkSends${type}Sharing`,
    component: SharingPage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
  {
    /**
     * Step 3 - Sequential vs Parallel
     */
    path: 'signing-sequence',
    name: `BulkSends${type}SigningSequence`,
    component: SigningSequencePage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
  {
    /**
     * Step 4 - Reminders
     */
    path: 'reminders',
    name: `BulkSends${type}Reminders`,
    component: RemindersPage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
  {
    /**
     * Step 5 - Expiry
     */
    path: 'expiry',
    name: `BulkSends${type}Expiry`,
    component: ExpiryPage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
];

export default [
  {
    /**
     * url: /bulk-send
     *
     * Page handles listing
     */
    path: '/bulk-send',
    name: 'BulkSends',
    component: IndexPage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
  {
    /**
     * url: /bulk-send/create
     *
     * Step 1 - First screen in flow for a new bulk-send. Since we
     * don't have any data related to it, we don't have a
     * fingerprint
     *
     */
    path: '/bulk-send/create',
    name: 'BulkSendsCreate',
    component: CreatePage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
  },
  {
    /**
     * StepsPage shows the current "step" with progress bar and back/next buttons
     */
    path: '/bulk-send/:fingerprint',
    name: 'BulkSendsSteps',
    component: StepsPage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
    children: [
      ...commonRoutes(),
      {
        /**
         * Step 6 - Select template/s
         */
        path: 'templates',
        name: 'BulkSendsStepTemplates',
        component: TemplatesPage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
        props: true,
      },
      {
        /**
         * Step 7 - Map roles
         */
        path: 'roles',
        name: 'BulkSendsStepRoles',
        component: RolesPage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
      {
        /**
         * Step 8 - Import CSV data
         */
        path: 'import-data',
        name: 'BulkSendsStepImportData',
        component: ImportDataPage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
      {
        /**
         * Step 9 - Review CSV data
         */
        path: 'review-data',
        name: 'BulkSendsStepReviewData',
        component: ReviewDataPage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
      {
        /**
         * Step 10 - Message
         */
        path: 'message',
        name: 'BulkSendsStepMessage',
        component: MessagePage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
      {
        /**
         * Step 11 - Summary
         */
        path: 'summary',
        name: 'BulkSendsStepSummary',
        component: SummaryPage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
      {
        /**
         * Step 12 - Credits usage
         */
        path: 'usage',
        name: 'BulkSendsStepUsage',
        component: UsagePage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
      {
        /**
         * Catch all - Steps page will redirect to correct step
         */
        path: '*',
      },
    ],
  },
  {
    /**
     * EditPage shows the "step" in an edit state without progress bar
     */
    path: '/bulk-send/:fingerprint/edit',
    name: 'BulkSendsEdit',
    component: StepsPage,
    meta: {
      title: 'bulkSend',
      requiresAuth: true,
    },
    children: [
      ...commonRoutes('Edit'),
      {
        /**
         * Step 10 - Message
         */
        path: 'message',
        name: 'BulkSendsEditMessage',
        component: MessagePage,
        meta: {
          title: 'bulkSend',
          requiresAuth: true,
        },
      },
    ],
  },
];
